import { sendEvent } from 'constants/mixpanelHelper';
import { GENERIC_EVENTS } from 'constants/trackingEvents';

export const sendClickedOnPreferencesEvent = ({
  eventName = GENERIC_EVENTS.MODULE_PREFERENCE_NAVIGATION,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnQuickHelpEvent = ({
  eventName = GENERIC_EVENTS.QUICK_HELP_CLICKED,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnPreferencesTabEvent = ({
  eventName = GENERIC_EVENTS.CLICKED_ON_PREFERENCES_TAB,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendExpandedReviewChartEvent = ({ eventName = GENERIC_EVENTS.EXPANDED_CHART, eventProperties = {} }) => {
  sendEvent({ eventName, eventProperties });
};
